var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66699 5.83301C3.66699 5.55687 3.89085 5.33301 4.16699 5.33301H15.8337C16.1098 5.33301 16.3337 5.55687 16.3337 5.83301C16.3337 6.10915 16.1098 6.33301 15.8337 6.33301H4.16699C3.89085 6.33301 3.66699 6.10915 3.66699 5.83301Z",
    fill: "#9093A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33398 10C5.33398 9.72386 5.55784 9.5 5.83398 9.5H14.1673C14.4435 9.5 14.6673 9.72386 14.6673 10C14.6673 10.2761 14.4435 10.5 14.1673 10.5H5.83398C5.55784 10.5 5.33398 10.2761 5.33398 10Z",
    fill: "#9093A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83398 14.166C7.83398 13.8899 8.05784 13.666 8.33398 13.666H11.6673C11.9435 13.666 12.1673 13.8899 12.1673 14.166C12.1673 14.4422 11.9435 14.666 11.6673 14.666H8.33398C8.05784 14.666 7.83398 14.4422 7.83398 14.166Z",
    fill: "#9093A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.383dd1ee.svg";
export { ForwardRef as ReactComponent };